import { NotificationsListType } from '../interfaces';
import { NotificationAPI } from '../api/notificationsAPI';
import { NotificationsList } from './notification-list/NotificationsList';

export function StandardNotificationsList() {
  return (
    <NotificationsList
      dataSource={(payload, options) => NotificationAPI.getNotifications(payload, options)}
      entity={NotificationsListType.REGULAR}
    />
  );
}
